import { render, staticRenderFns } from "./CastingForm.vue?vue&type=template&id=2dd268b2&scoped=true&"
import script from "./CastingForm.vue?vue&type=script&lang=js&"
export * from "./CastingForm.vue?vue&type=script&lang=js&"
import style0 from "./CastingForm.vue?vue&type=style&index=0&id=2dd268b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd268b2",
  null
  
)

component.options.__file = "CastingForm.vue"
export default component.exports